var $43993547bd42ef6e$exports = {};
$43993547bd42ef6e$exports = {
    "alert": `Figyelmeztet\xe9s`,
    "dismiss": `Elutas\xedt\xe1s`
};


export {$43993547bd42ef6e$exports as default};
//# sourceMappingURL=hu-HU.module.js.map
